import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Minus, Plus, RotateCcw, X } from "lucide-react";

export default function ImageLightbox({ images, index = 0, onClose }) {
  const [active, setActive] = useState(index);
  const [zoom, setZoom] = useState(1);
  const touch = useRef(null);
  const current = images[active];
  const move = (delta) => { setActive((value) => (value + delta + images.length) % images.length); setZoom(1); };
  useEffect(() => {
    const key = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft" && images.length > 1) move(-1);
      if (event.key === "ArrowRight" && images.length > 1) move(1);
    };
    document.addEventListener("keydown", key);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", key); document.body.style.overflow = ""; };
  });
  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-black/90" role="dialog" aria-modal="true" aria-label="Billedfremviser" onClick={onClose}>
      <div className="flex h-16 items-center justify-between px-4 text-white">
        <span className="text-sm">{active + 1} / {images.length}</span>
        <div className="flex items-center gap-1">
          <Icon label="Zoom ud" onClick={() => setZoom((value) => Math.max(1, value - .25))}><Minus/></Icon>
          <Icon label="Zoom ind" onClick={() => setZoom((value) => Math.min(4, value + .25))}><Plus/></Icon>
          <Icon label="Nulstil zoom" onClick={() => setZoom(1)}><RotateCcw/></Icon>
          <Icon label="Luk" onClick={onClose}><X/></Icon>
        </div>
      </div>
      <div className="relative flex flex-1 items-center justify-center overflow-auto p-4" onClick={(event) => event.stopPropagation()} onTouchStart={(event) => { touch.current = event.touches[0].clientX; }} onTouchEnd={(event) => { const end = event.changedTouches[0].clientX; if (touch.current && Math.abs(end - touch.current) > 45 && images.length > 1) move(end < touch.current ? 1 : -1); }}>
        {images.length > 1 && <button aria-label="Forrige billede" onClick={() => move(-1)} className="absolute left-3 z-10 rounded-full bg-black/50 p-2 text-white"><ChevronLeft/></button>}
        <img src={current.src} alt={current.alt || "Vedhæftet billede"} className="max-h-[78vh] max-w-[90vw] select-none object-contain transition-transform" style={{ transform: `scale(${zoom})`, cursor: zoom > 1 ? "grab" : "zoom-in" }} draggable={false}/>
        {images.length > 1 && <button aria-label="Næste billede" onClick={() => move(1)} className="absolute right-3 z-10 rounded-full bg-black/50 p-2 text-white"><ChevronRight/></button>}
      </div>
    </div>
  );
}
function Icon({ label, onClick, children }) { return <button type="button" aria-label={label} onClick={(event) => { event.stopPropagation(); onClick(); }} className="rounded-full p-2 hover:bg-white/15">{children}</button>; }
